import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 },
    ttl: { type: Number, default: 3000 }
  }

  connect() {
    this.typing = false
    this.lastPing = 0
    this.idleTimer = null
  }

  disconnect() {
    this.stop()
  }

  changed() {
    const field = this.element.querySelector("textarea, input")
    if (!field?.value?.trim()) {
      this.stop()
      return
    }

    this.ping()
    this.scheduleIdleStop()
  }

  stop() {
    clearTimeout(this.idleTimer)
    if (!this.typing) return

    this.typing = false
    this.lastPing = 0
    this.send(false)
  }

  ping() {
    const now = Date.now()
    if (this.typing && now - this.lastPing < this.intervalValue) return

    this.typing = true
    this.lastPing = now
    this.send(true)
  }

  scheduleIdleStop() {
    clearTimeout(this.idleTimer)
    this.idleTimer = setTimeout(() => this.stop(), this.ttlValue)
  }

  send(typing) {
    if (!this.urlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams({ typing: typing ? "true" : "false" })

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token
      },
      body,
      credentials: "same-origin",
      keepalive: true
    })
  }
}
